import { cx } from "@linaria/core";
import { Portal } from "reakit";
import React, { FC, memo, useRef } from "react";
import { cssPushCounterPositionTop, PushCounter } from "@/components/PushCounter";
import { useAppDispatch, useAppSelector } from "@/hooks/redux";
import { modalsAlias, setIsShowModal } from "@/store/reducers/commonSlice";
import { cssHiddenLG } from "@/styles/utils/Utils";
import { Button } from "@/ui/Button/Button";
import { ButtonGroup, cssButtonFill, cssButtonFloatRight } from "@/ui/Button/StyledButton";
import { Modal } from "@/ui/Modal/Modal";
import { Typography } from "@/ui/Typography/Typography";
import { StyledFiltersModals } from "./StyledFilterModals";
import useIntersectionObserver from "../../../hooks/useIntersectionObserver";
export type DesktopFiltersPropsType = {
  isExistFilters: boolean;
  filterCount: number;
};
export const DesktopFiltersModal: FC<DesktopFiltersPropsType> = memo(({
  children,
  isExistFilters,
  filterCount
}) => {
  const buttonRef = useRef<HTMLButtonElement>(null);
  const intersectionFilters = useIntersectionObserver(buttonRef, {});
  const inView = intersectionFilters?.isIntersecting;
  const count = filterCount || 1;
  const {
    isShow
  } = useAppSelector(({
    common
  }) => common.modals[modalsAlias.filter]);
  const dispatch = useAppDispatch();
  const toggleModal = () => {
    dispatch(setIsShowModal({
      isShow: !isShow,
      alias: modalsAlias.filter
    }));
  };
  return <>
        <ButtonGroup style={{
      flex: "auto"
    }} className={cssHiddenLG}>
          <Button variant={"translucent"} icon={"Filter"} size={"small"} ref={buttonRef} onClick={toggleModal}>
            Все фильтры
            {isExistFilters && <PushCounter className={cssPushCounterPositionTop} qty={count} />}
          </Button>
        </ButtonGroup>

        {inView !== undefined && !inView && <Portal>
            <Button className={cx(cssButtonFloatRight, cssButtonFill)} icon={"Filter"} variant={"box"} onClick={toggleModal}>
              {isExistFilters && <PushCounter qty={count} />}
            </Button>
          </Portal>}

        <Modal closeMode={"destroy"} variant={"rounded-0"} isShowModal={isShow} onClose={toggleModal}>
          <StyledFiltersModals>
            <Typography variant={"h3"}>Все фильтры</Typography>
            {children}
          </StyledFiltersModals>
        </Modal>
      </>;
});
DesktopFiltersModal.displayName = "DesktopFiltersModal";